<template>
  <svg role="presentation" class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="cls-1" d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z" />
    <path class="cls-1" d="M1.66675 10H18.3334" />
    <path class="cls-1" d="M10.0001 1.66667C12.0845 3.94863 13.269 6.91003 13.3334 10C13.269 13.09 12.0845 16.0514 10.0001 18.3333C7.91568 16.0514 6.73112 13.09 6.66675 10C6.73112 6.91003 7.91568 3.94863 10.0001 1.66667Z" />
  </svg>
</template>
<script>
export default {
  name: 'GlobeIcon'
}
</script>
<style lang="scss" scoped>
.icon {
  height: 2rem;
  width: 2rem;
}

.cls-1 {
  fill: none;
  stroke: var(--_zenith-header-text-link, var(--zenith-header-text-link));
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
